module.exports = __webpack_public_path__ + "static/media/form2.98048ff6.png";